import React from 'react';
import {ACTIVITY_OPTIONS, choiceCardClass} from '../constants';
import {StepProps, asRecord, listField} from './types';

/**
 * Шаг «Чем занимаетесь» (слот 8): сценарии носки. Ответ целиком уезжает в
 * `UserSettings.activitiesJson` и попадает в контекст AI-стилиста, поэтому вместе с кодами
 * сохраняем человекочитаемые подписи.
 */
const StepActivities: React.FC<StepProps> = ({value, onChange}) => {
    const selected = listField(value, 'activities');

    const toggle = (code: string) => {
        const next = selected.includes(code)
            ? selected.filter(c => c !== code)
            : [...selected, code];
        const labels = next
            .map(c => ACTIVITY_OPTIONS.find(o => o.code === c)?.label)
            .filter((label): label is string => Boolean(label));
        onChange({...asRecord(value), activities: next, labels});
    };

    return (
        <div className="flex flex-wrap gap-2" data-testid="onboarding-step-activities">
            {ACTIVITY_OPTIONS.map(opt => (
                <button
                    key={opt.code}
                    type="button"
                    onClick={() => toggle(opt.code)}
                    aria-pressed={selected.includes(opt.code)}
                    className={choiceCardClass(selected.includes(opt.code))}
                    data-testid={`onboarding-activity-${opt.code}`}
                >
                    {opt.label}
                </button>
            ))}
        </div>
    );
};

export default StepActivities;
